
















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
    name: "InputAtom",
    props: {
        inputLabel: {
            type: String,
            required: false
        },
        inputName: {
            type: String,
            required: true
        },
        inputClasses: {
            type: String,
            required: false,
            default: null
        },
        inputValue: {
            type: String,
            required: false,
            default: null
        },
        inputType: {
            type: String,
            required: false,
            default: "radio"
        },
        inputId: {
            type: String,
            required: true
        },
        isChecked: {
            type: Boolean,
            required: false,
            default: null
        },
        labelClasses: {
            type: String,
            required: false,
            default: null
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: null
        }
    },
    setup(props, { emit }) {
        const handleChange = (value: any, checked: any) => {
            if (props.inputType === 'radio' || props.inputType === 'checkbox') {
                emit('input-change', checked);
            } else {
                emit('input', value);
            }
        }

        return {
            handleChange,
        }
    }
})
